import React, { FC, useState } from 'react';
import moment from 'moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Button } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { formatMoney, formatMonthDayYear } from '../../../utils/utils';
import Table from '../../../Components/Table';
import Select from '../../../Components/Select';
import { useAdminsQuery } from '../graphql/admins.generated';
import { useGetPackagesLazyQuery } from '../graphql/getPackages.generated';

const PackagesTable: FC = () => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState<string>(moment().subtract(1, 'month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState<string>(moment().format('YYYY-MM-DD'));
  const [dateFilterType, setDateFilterType] = useState<'startsAt' | 'createdAt'>('startsAt');
  const [admin, setAdmin] = useState<string>();
  const { data: adminsData } = useAdminsQuery();
  const [getBookings, { data }] = useGetPackagesLazyQuery({
    variables: {
      dateRange: { startDate: startDate, endDate: endDate },
      adminIds: admin ? [admin] : undefined,
      dateRangeFilterType: dateFilterType
    }
  });

  const handleSearch = () => getBookings();

  const handleSetDateFrom = (value) => {
    const formattedDate = moment(value).format('YYYY-MM-DD');

    setStartDate(formattedDate);
  };

  const handleSetDateUntil = (value) => {
    const formattedDate = moment(value).format('YYYY-MM-DD');

    setEndDate(formattedDate);
  };

  const renderBookingTable = () => {
    const tableData =
      data?.getPackages.map((item) => {
        return {
          data: {
            name: item.packageName,
            customer: `${item.customer?.firstName || ''} ${item?.customer?.lastName || ''}`,
            totalAmount: item.customerPayment?.total?.amount ? formatMoney(item.customerPayment.total.amount) : '-',
            startDate: item.startDate ? formatMonthDayYear(+item.startDate) : '-',
            createdAt: item.createdAt ? formatMonthDayYear(+item.createdAt) : '-',
            createdBy: item.createdBy ? `${item.createdBy.firstName} ${item.createdBy.lastName}` : '-'
          },
          onRowClick: () => navigate(`/packages/${item.id}`)
        };
      }) || [];
    return <Table tableData={tableData} />;
  };

  const adminOptions =
    adminsData?.admins?.map((adminItem) => ({
      name: `${adminItem?.firstName || ''} ${adminItem?.lastName || ''}`,
      value: adminItem?.id || ''
    })) || [];

  const dateRangeFilterTypeOptions = [
    { name: 'Created at', value: 'createdAt' },
    { name: 'Starts at', value: 'startsAt' }
  ];

  return (
    <>
      <h1 className="my-6 text-3xl">Packages</h1>
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className="flex items-center space-x-4">
            <Select
              options={adminOptions}
              onChange={(event) => {
                console.log(event);
                setAdmin(event.target.value);
              }}
              value={admin}
              label="Created by"
              style={{ top: '0.25rem', marginRight: '1rem' }}
            />

            <Select
              options={dateRangeFilterTypeOptions}
              onChange={(event) => {
                console.log(event);
                setDateFilterType(event.target.value);
              }}
              value={dateFilterType}
              label="Type"
              style={{ top: '0.25rem', marginRight: '1rem' }}
            />

            <KeyboardDatePicker
              format="yyyy/MM/dd"
              margin="normal"
              id="date-picker-inline"
              label="Date from"
              onFocus={() => {}}
              onBlur={() => {}}
              inputVariant="outlined"
              onChange={handleSetDateFrom}
              value={startDate}
            />
            <KeyboardDatePicker
              format="yyyy/MM/dd"
              onFocus={() => {}}
              onBlur={() => {}}
              margin="normal"
              id="date-picker-inline"
              inputVariant="outlined"
              label="Date until"
              onChange={handleSetDateUntil}
              value={endDate}
            />
            <Button variant="outlined" onClick={handleSearch}>
              Search
            </Button>
          </div>
        </MuiPickersUtilsProvider>
      </div>
      <div style={{ marginTop: '2rem' }}>{renderBookingTable()}</div>
    </>
  );
};

export default PackagesTable;
